import { render, staticRenderFns } from "./LevelStats.vue?vue&type=template&id=25d1da76&scoped=true&lang=pug"
import script from "./LevelStats.vue?vue&type=script&lang=js"
export * from "./LevelStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d1da76",
  null
  
)

export default component.exports